import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstName'
})
export class FirstNamePipe implements PipeTransform {
    transform(name: string): string {
        if (!name) {
            return name;
        }

        // Remove quaisquer espaços em branco extras no início e fim da string
        const nameTrimmed = name.trim();
        // Divide a string em partes usando espaços como separadores
        const nameSplited = nameTrimmed.split(' ');
        // Retorna a primeira parte, que será o primeiro nome
        return nameSplited[0];
    }
}
